"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DocXls_exports = {};
__export(DocXls_exports, {
  default: () => DocXls_default
});
module.exports = __toCommonJS(DocXls_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00002 5.0999C7.22683 5.0999 6.60002 5.7267 6.60002 6.4999V9.4999C6.60002 9.83127 6.3314 10.0999 6.00002 10.0999C5.66865 10.0999 5.40002 9.83127 5.40002 9.4999V6.4999C5.40002 5.06396 6.56408 3.8999 8.00002 3.8999H14.6134C15.0114 3.8999 15.3952 4.04826 15.6897 4.316L18.0763 6.48564C18.4099 6.78888 18.6 7.21875 18.6 7.66955V9.4999C18.6 9.83127 18.3314 10.0999 18 10.0999C17.6687 10.0999 17.4 9.83127 17.4 9.4999V8.75H15C14.1716 8.75 13.5 8.07843 13.5 7.25V5.0999H8.00002ZM14.5 5.0999V7.25C14.5 7.52614 14.7239 7.75 15 7.75H17.4V7.66955C17.4 7.55685 17.3525 7.44938 17.2691 7.37357L14.8825 5.20393C14.8089 5.13699 14.7129 5.0999 14.6134 5.0999H14.5ZM21.9636 13.52L20.4756 13.976C20.3916 13.508 20.0076 12.776 18.9276 12.776C18.1236 12.776 17.5956 13.292 17.5956 13.856C17.5956 14.324 17.8956 14.696 18.5196 14.816L19.7076 15.044C21.2556 15.344 22.0836 16.352 22.0836 17.552C22.0836 18.86 20.9916 20.18 19.0116 20.18C16.7556 20.18 15.7596 18.728 15.6276 17.516L17.1636 17.108C17.2356 17.948 17.8236 18.704 19.0236 18.704C19.9116 18.704 20.4036 18.26 20.4036 17.66C20.4036 17.168 20.0316 16.784 19.3716 16.652L18.1836 16.412C16.8276 16.136 15.9516 15.26 15.9516 13.976C15.9516 12.464 17.3076 11.312 18.9156 11.312C20.9796 11.312 21.7716 12.56 21.9636 13.52ZM6.51825 15.752L9.30225 11.492H7.37025L5.51025 14.432L3.68625 11.492H1.69425L4.47825 15.74L1.68225 20H3.62625L5.47425 17.06L7.31025 20H9.31425L6.51825 15.752ZM9.98959 20H15.4376V18.416H11.6456V11.492H9.98959V20Z",
      fill: "currentColor"
    }
  )
);
const SvgDocXls = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DocXls_default = SvgDocXls;
